// extracted by mini-css-extract-plugin
export var contacts = "Contacts--contacts--SXj2q";
export var contacts__copyright = "Contacts--contacts__copyright--VVRV9";
export var contacts__email = "Contacts--contacts__email--F0d1L";
export var contacts__link = "Contacts--contacts__link--UeqIi";
export var contacts__phone = "Contacts--contacts__phone--oeyUi";
export var contacts__reg = "Contacts--contacts__reg--oJHS0";
export var tkMyriadProSemiCondensed = "Contacts--tk-myriad-pro-semi-condensed--jzims";